import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { lastValueFrom } from 'rxjs';

export interface NewplaAiUserMemoryDto {
  id: string;
  content: string;
  createdAt: string;
  updatedAt: string;
}

export interface NewplaAiUserMemoriesDto {
  limits: { maxItems: number; maxLength: number };
  memories: NewplaAiUserMemoryDto[];
}

/** 개인 AI 설정 API (/api/newpla-ai/user-setting). 로그인 사용자 자신의 것만 다룬다 */
@Injectable({ providedIn: 'root' })
export class NewplaAiUserSettingApi {

  private readonly baseUrl = '/api/newpla-ai/user-setting';
  private http = inject(HttpClient);

  findMyMemories(): Promise<NewplaAiUserMemoriesDto> {
    return lastValueFrom(this.http.get<NewplaAiUserMemoriesDto>(`${this.baseUrl}/memories`));
  }

  addMemory(content: string): Promise<NewplaAiUserMemoryDto> {
    return lastValueFrom(this.http.post<NewplaAiUserMemoryDto>(`${this.baseUrl}/memories`, { content }));
  }

  updateMemory(id: string, content: string): Promise<NewplaAiUserMemoryDto> {
    return lastValueFrom(this.http.put<NewplaAiUserMemoryDto>(`${this.baseUrl}/memories/${id}`, { content }));
  }

  deleteMemory(id: string): Promise<void> {
    return lastValueFrom(this.http.delete<void>(`${this.baseUrl}/memories/${id}`));
  }

  deleteAllMemories(): Promise<number> {
    return lastValueFrom(this.http.delete<number>(`${this.baseUrl}/memories`));
  }
}
